<tcm-main-frame [hideCommands]="true"></tcm-main-frame>